var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { staticClass: "stretch-grid has-search no-footer" },
    [
      _c("Grid", {
        staticClass: "fit",
        attrs: {
          id: "eventsGrid",
          loading: _vm.loading,
          module: _vm.module,
          data: _vm.eventList,
          columns: _vm.columnOptions,
          pagination: _vm.pagination,
          onRequest: _vm.fetchAll,
          rowsPerPageOptions: [10, 20, 30, 50, 100]
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }